import { Gem } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';

import { Badge } from '@/slw/shared/ui/badge';
import { formatCurrency } from '@/slw/shared/lib/format-number';
import { isLoggedInClient } from '@/slw/shared/lib/auth.client';
import { ListingByUser } from '@/slw/entities/buyer/dealer-listings/dealer-listings.type';

interface ListingItemProps {
  listing: ListingByUser;
}

export function ListingItem({ listing }: ListingItemProps) {
  const isLogged = isLoggedInClient();

  const renderLocation = () => {
    let location = '';

    if (listing.stateName && !listing.countryName) {
      location = listing.stateName;
    }

    if (!listing.stateName && listing.countryName) {
      location = listing.countryName;
    }

    if (listing.stateName && listing.countryName) {
      location = `${listing.stateName}, ${listing.countryName}`;
    }

    return location;
  };

  return (
    <div
      className='product-item bg-sidebar rounded-[8px] p-2 mb-2 md:mb-4
    hover:[&_img.car-img]:transform-[scale(1.2)] flex flex-col md:flex-row gap-4 md:gap-6'
    >
      <div className='relative rounded-[6px] overflow-hidden flex-2/5'>
        <Link href={`/listing/${listing.url}`}>
          <Image
            className='rounded-[6px] w-full transition-all duration-300 object-cover object-center car-img'
            src={listing.mainImageUrl}
            alt=''
            width={350}
            height={196}
          />

          {listing.isPremiumSpotlight && (
            <span
              className='absolute top-3 left-0 bg-[#FF2D55] 
           text-white text-sm px-4 py-1 rounded-tr-md rounded-br-md flex items-center gap-2'
            >
              <Gem size={16} className='inline-block' />
              Premium Spotlight
            </span>
          )}
        </Link>
      </div>

      <div className='flex flex-col gap-2 px-1 pb-1 mt-4 flex-3/5'>
        <div className='flex items-center justify-between'>
          <Link href={`/listing/${listing.url}`} className='block font-bold'>
            {listing.subTitle}
          </Link>
          {isLogged && !listing.isFavourite && <img src='/images/icon/icon-favorite-1.png' alt='' />}
          {isLogged && listing.isFavourite && <img src='/images/icon/icon-favorite-2.png' alt='' />}
        </div>
        {listing.vehicleEraName && (
          <div>
            <Badge
              variant='outline'
              className='bg-primary text-white rounded-md text-sm border-none leading-[120%] font-normal py-0.75'
            >
              {listing.vehicleEraName}
            </Badge>
          </div>
        )}

        <div className='text-lg font-bold text-primary leading-[160%]'>{formatCurrency(listing.price)}</div>
        <div className='flex items-center justify-between text-sm font-normal leading-[150%]'>
          <span className='flex items-center gap-2'>
            <img src='/images/icon/icon-map-maker.png' alt='' />
            {renderLocation()}
          </span>
          <span>{listing.listingId}</span>
        </div>
      </div>
    </div>
  );
}
